import { Box } from '@mui/system';
import React, { useContext } from 'react';
import SampleTaxCalculation from './SampleTaxCalculation';
import { ModalContext } from '@/state/ModalProvider';
import { TaxGuideContext } from '@/state/TaxGuideProvider';
import LoadingShimmer from '@/pages/LoadingShimmer';
import DOMPurify from 'dompurify';
import { NotFoundComponent } from '../NotFound';
import RenderContent from './RenderContent';
import useTaxCalculationPopup from '@/ui/hooks/useTaxCalculationModal';

export const TaxGuideContent = () => {
  const { content, isPending, isFetching } = useContext(TaxGuideContext);
  const modalStatus = useContext(ModalContext);
  useTaxCalculationPopup({ content, modalStatus });

  if (isPending && isFetching) return <LoadingShimmer call="partial" />;
  if (!content?.data) return null;
  if (!content?.data?.content) return <NotFoundComponent />;

  const { chartContents } = content.data;
  const chartResponse = chartContents;
  const sanitizedBlog = DOMPurify.sanitize(content.data.content);

  return (
    <Box
      id={'taxGuideContent'}
      style={{
        paddingBottom: 40,
        paddingTop: 4,
        paddingLeft: 16,
        paddingRight: 16,
      }}
    >
      <RenderContent htmlString={sanitizedBlog} chartContents={chartResponse} />
      {modalStatus.showModal && <SampleTaxCalculation />}
    </Box>
  );
};
